import React from 'react';

const DEFAULT_ICON_SIZE = { w: 36, h: 24 };

type Props = {
  w?: number;
  h?: number;
  className?: string;
};

const WalletConnectIcon = ({ className, w, h }: Props): JSX.Element => {
  return (
    <svg
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 36 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.37 5.298c5.87-5.73 15.39-5.73 21.26 0l.707.69a.722.722 0 0 1 0 1.038l-2.417 2.36a.382.382 0 0 1-.532 0l-.972-.95c-4.096-3.998-10.736-3.998-14.832 0L9.543 9.453a.382.382 0 0 1-.532 0l-2.417-2.36a.722.722 0 0 1 0-1.038l.776-.757zm26.259 4.88 2.15 2.1a.722.722 0 0 1 0 1.038l-9.699 9.47a.765.765 0 0 1-1.063 0l-6.884-6.721a.191.191 0 0 0-.266 0l-6.884 6.72a.765.765 0 0 1-1.063 0l-9.7-9.47a.722.722 0 0 1 0-1.037l2.151-2.1a.765.765 0 0 1 1.063 0l6.885 6.72a.191.191 0 0 0 .265 0l6.884-6.72a.765.765 0 0 1 1.063 0l6.885 6.72a.191.191 0 0 0 .265 0l6.885-6.72a.765.765 0 0 1 1.063 0z"
        fill="#3B99FC"
        fillRule="nonzero"
      />
    </svg>
  );
};

WalletConnectIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default WalletConnectIcon;
